import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel } from '@mui/material';
import { Typography } from '@totalsoft/rocket-ui';
import { onCheckBoxChange } from 'utils/propertyChangeAdapters';

const LabeledCheckbox = ({ checked, label, labelVariant = 'subtitle2', onChange, disabled, required, formControlProps, checkboxProps }) => {
  return (
    <FormControlLabel
      label={<Typography variant={labelVariant}>{label}</Typography>}
      control={<Checkbox checked={checked || false} onChange={onChange |> onCheckBoxChange} {...checkboxProps} />}
      disabled={disabled}
      required={required}
      sx={{ ml: 0 }}
      {...formControlProps}
    />
  );
};

LabeledCheckbox.propTypes = {
  checked: PropTypes.bool,
  label: PropTypes.string,
  labelVariant: PropTypes.string,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  formControlProps: PropTypes.object,
  checkboxProps: PropTypes.object
};

export default LabeledCheckbox;
